export const SCHOOL_TIMEZONE = 'Asia/Bangkok';
